import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import createMuiTheme from "@material-ui/core/es/styles/createMuiTheme";
const grey900 = grey['900'];
const red500 = red['500'];

export default createMuiTheme({
    palette: {
        primary: {
            main: '#3d46a3'
        },
        secondary: {
            main: red500,
        },
    },
    appBar: {
        height: 57,
        color: '#3d46a3'
    },
    drawer: {
        width: 230,
        color: grey900
    },
    raisedButton: {
        primaryColor: '#3d46a3',
    },
    toolbar: {
        height: 160
    }
});





// WEBPACK FOOTER //
// ./src/ultimahq-theme.js